import DestructorTree from "lib/DestructorTree";
import { api_configuration } from "../../common";
import api_client_state = api_configuration.types.client_state.alan_api;
export type NumberConverter = {
	to: (destructor: DestructorTree) => (value: number, callback: (result: number) => void) => void;
	onceTo: (value: number) => number;
	from: (value: number) => number;
};

export const noConversion: NumberConverter = {
	to: () => (value, callback) => callback(value),
	onceTo: (value) => value,
	from: (value) => value,
};

export function makeNumberConverter(
	numerical_type_properties: api_client_state.Cyes__initialized__numerical_type_properties
): NumberConverter {
	let decimals = Math.min(numerical_type_properties.properties.decimals.value, 20);
	return {
		to: (destructor) => {
			let local_callback: ((result: number) => void) | undefined = undefined;
			let local_value: number | undefined = undefined;
			destructor.subscribeToNumber(numerical_type_properties, "subscribe_decimals", (new_decimals) => {
				decimals = Math.min(new_decimals, 20);
				if (local_value !== undefined) {
					local_callback?.(applyToConversion(local_value, decimals));
				}
			});
			destructor.onDestroy(() => {
				local_callback = undefined;
			});

			return (value, callback) => {
				local_value = value;
				local_callback = callback;
				callback(applyToConversion(local_value, decimals));
			};
		},
		onceTo: (value) => applyToConversion(value, decimals),
		from: (value) => {
			if (!value) {
				return value;
			}
			return Math.round(value * Math.pow(10, decimals));
		},
	};
}

export function applyToConversion(value: number, decimals: number): number {
	if (decimals === 0) {
		return value;
	} else {
		return Number((value / Math.pow(10, decimals)).toFixed(decimals));
	}
}
